import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ChevronLeftFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM13.9316 16.8717C13.7001 17.1034 13.2478 17.0938 12.9997 16.8543L8.79828 12.8574C8.30426 12.398 8.30033 11.6163 8.79828 11.1443L12.9997 7.15615C13.2739 6.89926 13.67 6.88966 13.9229 7.13003C14.198 7.3839 14.2028 7.81805 13.9364 8.07585L9.79808 12.0009L13.9364 15.9346C14.198 16.1837 14.1989 16.6052 13.9316 16.8717Z"
        fill={color}
      />
    </svg>
  );
};

export { ChevronLeftFilledSvg };
